var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.981 6.64577C16.6728 6.64577 16.673 6.17702 16.981 6.17702C17.2038 6.17702 17.137 5.82803 17.137 5.49475C17.137 5.24127 16.7469 5.43545 16.7469 5.1044C16.7469 4.66986 17.6053 4.86522 17.6053 5.49475V6.02081C17.6052 6.36557 17.3251 6.64577 16.9809 6.64577H16.981ZM13.6461 6.64577C13.5169 6.64577 13.4121 6.54077 13.4121 6.41139C13.4121 4.66834 13.2311 4.8699 14.2382 4.8699C14.5464 4.8699 14.5462 5.33866 14.2382 5.33866H13.8803V6.41139C13.8802 6.541 13.7753 6.64577 13.6462 6.64577H13.6461Z",
    fill: "#4B6274"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9813 4.03112C16.6731 4.03112 16.6733 3.56237 16.9813 3.56237C17.204 3.56237 17.1373 3.20858 17.1373 2.88033C17.1373 2.7942 17.0672 2.72412 16.9813 2.72412H13.8804V3.56249C14.1195 3.56249 14.4723 3.50295 14.4723 3.79686C14.4723 4.11479 14.0316 4.03124 13.6461 4.03124C13.517 4.03124 13.4121 3.92624 13.4121 3.79686V2.48975C13.4121 2.36037 13.5171 2.25537 13.6461 2.25537H16.9812C17.3253 2.25537 17.6056 2.5358 17.6056 2.88033V3.40639C17.6054 3.75104 17.3254 4.03124 16.9812 4.03124L16.9813 4.03112Z",
    fill: "#4B6274"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5727 5.33848H14.2379C14.1087 5.33848 14.0039 5.23348 14.0039 5.10411V3.79688C14.0039 3.6675 14.1089 3.5625 14.2379 3.5625H17.5727C17.9168 3.5625 18.1971 3.84293 18.1971 4.18746V4.71352C18.1971 5.05805 17.9169 5.33848 17.5727 5.33848ZM14.4721 4.86973H17.5727C17.7954 4.86973 17.7287 4.51571 17.7287 4.18746C17.7287 4.10274 17.6574 4.03125 17.5727 4.03125H14.4721V4.86973Z",
    fill: "#E2725A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6573 5.5374C10.5281 5.5374 10.4233 5.4324 10.4233 5.30303V0.695432C10.4233 0.630275 10.3684 0.575197 10.3033 0.575197H3.17606C3.11102 0.575197 3.05594 0.630158 3.05594 0.695432V5.30303C3.05594 5.61158 2.58789 5.61158 2.58789 5.30303V0.695432C2.58789 0.370587 2.85168 0.106445 3.17606 0.106445H10.3033C10.6276 0.106445 10.8915 0.370587 10.8915 0.695432V5.30303C10.8914 5.4324 10.7865 5.5374 10.6573 5.5374Z",
    fill: "#4B6274"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7351 6.64573H2.74488C2.22527 6.64573 1.80269 6.22233 1.80269 5.70213C1.80269 5.43717 1.73847 5.06885 2.03672 5.06885H11.4436C11.7419 5.06885 11.6777 5.43717 11.6777 5.70213C11.6777 6.22256 11.255 6.64573 10.7351 6.64573ZM2.27074 5.5376C2.27074 5.83092 2.33086 6.17698 2.74488 6.17698H10.7351C11.1493 6.17698 11.2094 5.83104 11.2094 5.5376H2.27074Z",
    fill: "#E2725A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5091 8.03747H0.490861C-0.126954 8.03747 0.0137889 7.25207 0.0137889 6.65453C0.0137889 6.39098 0.227657 6.17676 0.490861 6.17676H19.5091C20.1269 6.17676 19.9864 6.9618 19.9863 7.55958C19.9861 7.82301 19.772 8.03747 19.5091 8.03747ZM0.490861 6.64551L0.481955 7.55958H19.5181V6.65453L0.490978 6.64551H0.490861Z",
    fill: "#4B6274"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2427 15.8633H13.7438C13.6146 15.8633 13.5098 15.7582 13.5098 15.6289V7.80274C13.5098 7.67336 13.6148 7.56836 13.7438 7.56836H19.2427C19.3719 7.56836 19.4767 7.67336 19.4767 7.80274V15.6287C19.477 15.758 19.372 15.8633 19.2427 15.8633ZM13.978 15.3943H19.0087V8.03711H13.978V15.3943Z",
    fill: "#4B6274"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26008 15.894H1.22719C0.963985 15.894 0.75 15.6795 0.75 15.4161V7.80322C0.75 7.67385 0.854883 7.56885 0.984024 7.56885H2.50313C2.63227 7.56885 2.73716 7.67385 2.73716 7.80322V15.4163C2.73716 15.6797 2.52305 15.894 2.26008 15.894ZM1.21805 8.0376V15.4163H2.26911V8.0376H1.21793H1.21805Z",
    fill: "#4B6274"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2427 11.9507H13.7438C13.4356 11.9507 13.4358 11.4819 13.7438 11.4819H19.2427C19.5508 11.4819 19.5509 11.9507 19.2427 11.9507Z",
    fill: "#4B6274"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9491 9.99365H16.0377C15.7295 9.99365 15.7297 9.5249 16.0377 9.5249H16.9491C17.2572 9.5249 17.2573 9.99365 16.9491 9.99365Z",
    fill: "#E2725A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9491 13.9067H16.0377C15.7295 13.9067 15.7297 13.438 16.0377 13.438H16.9491C17.2572 13.438 17.2573 13.9067 16.9491 13.9067Z",
    fill: "#E2725A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceIcon);
export default __webpack_public_path__ + "static/media/workspace-icon.33e42f59de1b1b1ead25e8062d4d1a8a.svg";
export { ForwardRef as ReactComponent };